require('./scrollIntoViewIfNeeded')
require('promise.prototype.finally').shim()

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector
}
